Ext.define('SA.LocationSeriesRequests', {
    singleton: true,

    async get(data) {
        var getFieldName = field => Array.isArray(field) ? field[2] : field,
            {select} = data,
            results = await SA.Ajax.request({resource: 'data/location', data});

        return results.map(result => Object.fromEntries(select.map((field, i) => [getFieldName(field), result[i]])));
    }
});